import * as React from 'react';
import { connect } from 'react-redux';
import './SettingsPane.css';
import {
	Panel,
	PanelType,
	Pivot,
	PivotItem,
	PivotLinkSize,
	PivotLinkFormat,
	IconButton,
	PrimaryButton,
	ChoiceGroup,
	TextField,
	Checkbox,
	Stack,
	SpinButton,
	TooltipHost,
	Label,
} from '@fluentui/react';
import { types } from '../../constants/types';
import { types as webTypes } from '../../../store/types';
import { ExclusionsMO } from '../../models/ExclusionsMO';
import { ThemeMO } from '../../models/ThemeMO';
import { ConfigManager } from '../../Manager/ConfigManager';
import { LocalStorageManager } from '../../Manager/LocalStorageManager';
import CustomExclusionText from './CustomExclusionText';

interface AppProps {
	//
	refreshAction;

	//
	isShowSettingsPane;
	setHideSettingsPane;

	setExclusionsMO;
	refreshWebTextInput: Function;
	exclusionsMO: ExclusionsMO;

	setThemeMO;
	themeMO: ThemeMO;
}

interface AppState {
	//
	isShowCustomTheme: boolean;
	unsaveExclusionsMO: ExclusionsMO;
	unsaveThemeMO: ThemeMO;
}

class SettingsPane extends React.Component<AppProps, AppState> {
	CUSTOM_KEY = ConfigManager.getCustomThemeKey();

	constructor(props, context) {
		super(props, context);

		// init data
		this.state = {
			isShowCustomTheme: this.props.themeMO.key === this.CUSTOM_KEY,
			unsaveExclusionsMO: this.props.exclusionsMO,
			unsaveThemeMO: this.props.themeMO,
		};
	}

	private getUnsaveExclusionsValue = (name) => {
		const { unsaveExclusionsMO } = this.state;
		return unsaveExclusionsMO[name];
	};

	private setUnsaveExclusionsValue = (name, newValue) => {
		const { unsaveExclusionsMO } = this.state;
		var settingEntry: any = {};
		settingEntry[name] = newValue;

		if (name === 'customExclusion') {
			settingEntry.lowerCaseCustomExclusion = newValue.map((value) =>
				value.toLowerCase(),
			);
		}
		const updatedSettings = {
			...unsaveExclusionsMO,
			...settingEntry,
		};

		this.setState({
			...this.state,
			unsaveExclusionsMO: updatedSettings,
		});
		this.saveExclusionsMO(updatedSettings);
	};

	private getUnsaveThemeValue = (name) => {
		const { unsaveThemeMO } = this.state;
		return unsaveThemeMO[name];
	};

	private setUnsaveThemeValue = (name, newValue) => {
		const { unsaveThemeMO } = this.state;

		var settingEntry = {};

		settingEntry[name] = newValue;

		const updatedSettings = {
			...unsaveThemeMO,
			...settingEntry,
		};
		updatedSettings.customeThemeRatings = updatedSettings.ratings;
		this.saveThemeMO(updatedSettings);
	};

	renderLabelWithTooltip = (label, tooltipText): any => {
		return (
			<span>
				<span>{label} </span>
				<TooltipHost content={tooltipText}>
					<IconButton
						className="question-btn"
						iconProps={{
							iconName: 'Info',
						}}
					/>
				</TooltipHost>
			</span>
		);
	};
	private renderExclusionsCheckbox = (name, label, tooltipText) => {
		const settingValue = this.getUnsaveExclusionsValue(name);
		return (
			<Checkbox
				label={label}
				onRenderLabel={() => this.renderLabelWithTooltip(label, tooltipText)}
				onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
					this.setUnsaveExclusionsValue(name, ev.target.checked);
				}}
				checked={settingValue}
			/>
		);
	};

	renderThemeTab = () => {
		const ratingLabelPresets = ConfigManager.getRatingLabelPresets();

		const _onChange = (_ev, option) => {
			let _themeMO = ConfigManager.getThemeByKey(option.key);
			this.saveThemeMO(_themeMO);

			if (option.key === this.CUSTOM_KEY) {
				this.setState({ isShowCustomTheme: true });
			} else {
				this.setState({ isShowCustomTheme: false });
			}
		};

		const onRenderCustomTheme = () => {
			const settingValue = this.getUnsaveThemeValue('ratings');
			const ratingHandler = (ev: React.ChangeEvent<HTMLInputElement>, pos) => {
				let newValue = [...settingValue];
				newValue[pos] = ev.target.value;
				this.setUnsaveThemeValue('ratings', newValue);
			};

			return (
				<div>
					<TextField
						className="ms-fontWeight-light theme-label-caption"
						label="1 (Best)"
						value={settingValue[0]}
						onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
							ratingHandler(ev, 0);
						}}
					/>
					<TextField
						className="ms-fontWeight-light theme-label-caption"
						label="2"
						value={settingValue[1]}
						onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
							ratingHandler(ev, 1);
						}}
					/>
					<TextField
						className="ms-fontWeight-light theme-label-caption"
						label="3"
						value={settingValue[2]}
						onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
							ratingHandler(ev, 2);
						}}
					/>
					<TextField
						className="ms-fontWeight-light theme-label-caption"
						label="4"
						value={settingValue[3]}
						onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
							ratingHandler(ev, 3);
						}}
					/>
					<TextField
						className="ms-fontWeight-light theme-label-caption"
						label="5 (Worst)"
						value={settingValue[4]}
						onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
							ratingHandler(ev, 4);
						}}
					/>
				</div>
			);
		};

		const onRenderLanguageChoiceLabel = (props) => {
			return (
				<span id={props.labelId} className="ms-ChoiceFieldLabel">
					<span>{props.text}</span>
					<span className="ms-fontWeight-light theme-label-caption">
						{props.themeQuestion !== '' ? `: ${props.themeQuestion}` : null}
					</span>
				</span>
			);
		};

		const options = ratingLabelPresets.map((preset) => {
			return {
				...preset,
				text: preset.themeTitle,
				onRenderLabel: onRenderLanguageChoiceLabel,
			};
		});

		const onRenderLanguageCurrentChoice = () => {
			const { unsaveThemeMO } = this.state;
			return (
				<div className="currentscores  ms-font-s ms-fontWeight-bold">
					<p>
						{unsaveThemeMO.key !== 'sunny-weather' ? (
							`${unsaveThemeMO.ratings[0]} - ${unsaveThemeMO.ratings[1]} - ${unsaveThemeMO.ratings[2]} - ${unsaveThemeMO.ratings[3]} - ${unsaveThemeMO.ratings[4]}`
						) : (
							<span>
								<span className="emoji-font">{unsaveThemeMO.ratings[0]}</span>
								{' - '}
								<span className="emoji-font">{unsaveThemeMO.ratings[1]}</span>
								{' - '}
								<span className="emoji-font">{unsaveThemeMO.ratings[2]}</span>
								{' - '}
								<span className="emoji-font">{unsaveThemeMO.ratings[3]}</span>
								{' - '}
								<span className="emoji-font">{unsaveThemeMO.ratings[4]}</span>
							</span>
						)}
					</p>
				</div>
			);
		};
		const useDefaultTheme = () => {
			let newTheme = ConfigManager.getDefaultTheme();
			this.saveThemeMO(newTheme);
			this.setState({ isShowCustomTheme: false });
		};

		return (
			<div>
				{onRenderLanguageCurrentChoice()}
				<ChoiceGroup
					options={options}
					onChange={_onChange}
					selectedKey={this.state.unsaveThemeMO.key}
					required={true}
				/>
				{this.state.isShowCustomTheme === true ? onRenderCustomTheme() : null}
				<br />
				<div
					className="defaultSettingLink"
					onClick={() => {
						useDefaultTheme();
					}}>
					Use default theme
				</div>
				<br />
				<br />
			</div>
		);
	};

	renderExclusionTab = () => {
		const stackTokens = { childrenGap: 10 };
		const { unsaveExclusionsMO } = this.state;
		const suffix = ' words';
		const maxWord = 1000000;

		const hasSuffix = (value: string, unitSuffix: string): Boolean => {
			const subString = value.substr(value.length - unitSuffix.length);
			return subString === unitSuffix;
		};

		const removeSuffix = (value: string, unitSuffix: string): string => {
			if (!hasSuffix(value, unitSuffix)) {
				return value;
			}
			return value.substr(0, value.length - suffix.length);
		};

		const onSpinButtonIncrement = (value: string) => {
			value = removeSuffix(value, suffix);
			let result: number = maxWord;
			if (Number(value) + 1 > maxWord) {
			} else {
				result = Number(value) + 1;
			}

			this.setUnsaveExclusionsValue('wordCountLessThan', result);

			return String(result) + suffix;
		};

		const onSpinButtonDecrement = (value: string) => {
			value = removeSuffix(value, suffix);
			let result: number = 0;
			if (Number(value) - 1 < 0) {
			} else {
				result = Number(value) - 1;
			}

			this.setUnsaveExclusionsValue('wordCountLessThan', result);

			return String(result) + suffix;
		};

		const onSpinButtonValidate = (value: string) => {
			value = removeSuffix(value, suffix);

			if (
				Number(value) > maxWord ||
				Number(value) < 0 ||
				value.trim().length === 0 ||
				isNaN(+value)
			) {
				value = '0';
			}

			this.setUnsaveExclusionsValue('wordCountLessThan', value);

			return String(value) + suffix;
		};

		// update unsaveExclusionsMO from default settings.
		const useDefaultSeting = () => {
			let _exclusionsMO = ConfigManager.getDefaultExclusions();
			this.setState({
				unsaveExclusionsMO: _exclusionsMO,
			});
			this.saveExclusionsMO(_exclusionsMO);
		};

		return (
			<div>
				<br />
				<p className="ms-fontWeight-light ms-font-s">
					Types of text to be excluded from test results.
				</p>
				<Stack tokens={stackTokens}>
					{this.renderExclusionsCheckbox(
						'parens',
						'Text within parentheses',
						'Excludes all text inside parentheses from the word count, a useful option if your document employs a parenthetical citation style such as APA or MLA.',
					)}
					{this.renderExclusionsCheckbox(
						'singleQuotes',
						'Text within single quotes',
						'Excludes all text within single quotation marks from the word count; please note that ticking this option may lead to large chunks of text being accidentally excluded if your sample contains misplaced single quotation marks or apostrophes.',
					)}
					{this.renderExclusionsCheckbox(
						'doubleQuotes',
						'Text within double quotes',
						'Excludes all text within double quotation marks from the word count; please note that ticking this option may lead to large chunks of text being excluded if your sample contains misplaced or missing double quotation marks.',
					)}
				</Stack>
				<br />

				<Label>
					{this.renderLabelWithTooltip(
						'Paragraphs with a word count less than:',
						'Very short paragraphs (<25 words) are excluded by default as they are likely to represent headers or list items rather than main text.  If desired, you can increase or decrease the default exclusion quantity.',
					)}
				</Label>
				<SpinButton
					min={0}
					max={maxWord}
					value={unsaveExclusionsMO.wordCountLessThan + suffix}
					onValidate={onSpinButtonValidate}
					onIncrement={onSpinButtonIncrement}
					onDecrement={onSpinButtonDecrement}
					incrementButtonAriaLabel={'Increase value by 1'}
					decrementButtonAriaLabel={'Decrease value by 1'}
				/>
				<br />
				<CustomExclusionText
					renderLabelWithTooltip={this.renderLabelWithTooltip}
					setUnsaveExclusionsValue={this.setUnsaveExclusionsValue}
					customExclusion={unsaveExclusionsMO.customExclusion}
				/>
				<p className="ms-fontWeight-light ms-font-s">
					Add words separated by a new line.
				</p>
				<br />
				<div
					className="defaultSettingLink"
					onClick={() => {
						useDefaultSeting();
					}}>
					Use default settings
				</div>

				<br />
				<br />
			</div>
		);
	};

	cancelButtonHandler = () => {
		const { setHideSettingsPane, refreshAction } = this.props;
		setHideSettingsPane();
		refreshAction();
	};

	saveThemeMO = (themeMO: ThemeMO) => {
		const { setThemeMO, refreshWebTextInput } = this.props;
		this.setState({
			...this.state,
			unsaveThemeMO: themeMO,
		});
		setThemeMO(themeMO);
		LocalStorageManager.setThemeMOToLocalStorage(themeMO);
		setTimeout(refreshWebTextInput, 100);
	};
	saveExclusionsMO = (exclusionsMO: ExclusionsMO) => {
		const { setExclusionsMO, refreshWebTextInput } = this.props;
		this.setState({
			unsaveExclusionsMO: exclusionsMO,
		});
		setExclusionsMO(exclusionsMO);
		LocalStorageManager.setExclusionsMOToLocalStorage(exclusionsMO);
		setTimeout(refreshWebTextInput, 100);
	};

	render() {
		const { isShowSettingsPane } = this.props;

		const onRenderHeaderContent = () => {
			return (
				<div className="s-header">
					<div className="text">Settings</div>

					<PrimaryButton
						className="close-btn"
						onClick={this.cancelButtonHandler}>
						Save
					</PrimaryButton>
				</div>
			);
		};

		const onRenderBodyContent = () => {
			return (
				<div className="s-body">
					<Pivot
						linkFormat={PivotLinkFormat.tabs}
						linkSize={PivotLinkSize.normal}>
						<PivotItem headerText="Theme">
							<br />
							<p className="ms-fontWeight-light ms-font-s">
								Customize the theme.
							</p>
							{this.renderThemeTab()}
						</PivotItem>
						<PivotItem headerText="Exclusions">
							{this.renderExclusionTab()}
						</PivotItem>
					</Pivot>
				</div>
			);
		};

		return (
			<Panel
				hasCloseButton={false}
				type={PanelType.smallFixedFar}
				onRenderHeader={onRenderHeaderContent}
				onRenderBody={onRenderBodyContent}
				isOpen={isShowSettingsPane}
				isFooterAtBottom={true}
				onDismiss={() => {
					this.cancelButtonHandler();
				}}></Panel>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	setHideSettingsPane: () => {
		dispatch({ type: types.HIDE_SETTINGS_PANE });
	},
	setExclusionsMO: (exclusionsMO) => {
		dispatch({
			type: types.SET_EXCLUSIONS,
			exclusionsMO: exclusionsMO,
		});
	},
	setThemeMO: (themeMO) => {
		dispatch({
			type: types.SET_THEME,
			themeMO: themeMO,
		});
	},
	refreshWebTextInput: () => {
		dispatch({ type: webTypes.REFRESH_TEXT_INPUT });
	},
});

const mapStateToProps = ({ isShowSettingsPane, exclusionsMO, themeMO }) => ({
	isShowSettingsPane,
	exclusionsMO,
	themeMO,
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPane);
